import * as ACTIONS from '../actions/store'

export default function reducer (state = {
  store: null,
  loading: false,
  faqs: null,
  error: null,
  currentFaq: null
}, action) {
  switch (action.type) {
    case ACTIONS.FETCH_STORE: {
      return {...state, loading: true}
    }
    case ACTIONS.FETCH_STORE_REJECTED: {
      return {...state, loading: false, error: action.payload}
    }
    case ACTIONS.FETCH_STORE_FULFILLED: {
      return {...state, loading: false, store: action.payload.store, faqs: action.payload.faqs}
    }
    case ACTIONS.SET_CURRENT_FAQ: {
      return {...state, currentFaq: action.payload}
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/store.js